export const AppRoutes = {
  Login: () => '/login',
  AccountSettings: () => '/account-settings',
  Dashboard: () => '/dashboard',
  // Revenue
  UsersOverview: () => '/users-overview',
  CashFlow: () => '/cash-flow',
  ChurnOverview: () => '/churn-overview',
  // Engagement
  Sections: () => '/engagement/sections',
  Songs: () => '/songs',
  Videos: () => '/videos',
  Events: () => '/events',
  Community: () => '/community',
  Chat: () => '/chat',
  EngagementUsers: () => '/engagement/users',
  TopSongListeners: () => '/engagement/users/song',
  TopForumPosters: () => '/engagement/users/forum',
  TopChatMessengers: () => '/engagement/users/chat',
  UserDirectory: () => '/database/users',
  Reports: () => '/reports',
  // Admin Panel
  Moderation: () => '/moderation',
  KeywordFlagging: () => '/keyword-flagging',
  KeywordFlaggingNew: () => '/keyword-flagging/new',
  KeywordFlaggingEdit: () => '/keyword-flagging/edit',
  KeywordFlaggingEditId: (id: string) => `/keyword-flagging/edit/${id}`,
  Polls: () => '/polls',
  PollsNew: () => '/polls/new',
  PollsEdit: () => '/polls/edit',
  PollsEditId: (postId: string) => `/polls/edit/${postId}`,
  AdminEvents: () => '/admin/events',
  AdminEventsCreate: () => '/admin/events/create',
  AdminEventsEditBase: () => '/admin/events/:eventId/edit',
  AdminEventsEdit: (id: string | number) => `/admin/events/${id}/edit`,
  AdminPresalePoolCreate: () => '/admin/events/presale-pool/create',
  AdminPresalePoolEdit: () => '/admin/events/presale-pool/edit'
}
